import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'SSL Encrypted',
      description: 'Your data is protected with 256-bit SSL encryption'
    },
    {
      icon: 'Lock',
      title: 'Secure Storage',
      description: 'Documents stored with bank-level security'
    },
    {
      icon: 'CheckCircle',
      title: 'GDPR Compliant',
      description: 'Full compliance with data protection regulations'
    }
  ];

  return (
    <div className="mt-12">
      <div className="text-center mb-6">
        <h3 className="text-lg font-heading font-medium text-foreground mb-2">
          Trusted by Real Estate Professionals
        </h3>
        <p className="text-muted-foreground font-body text-sm">
          Your contracts and client data are protected with enterprise-grade security
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {securityFeatures.map((feature, index) => (
          <div
            key={index}
            className="bg-card/50 backdrop-blur-sm border border-border/50 rounded-lg p-4 text-center hover:bg-card/70 transition-colors duration-200"
          >
            <div className="w-12 h-12 bg-success/10 rounded-lg flex items-center justify-center mx-auto mb-3">
              <Icon 
                name={feature.icon} 
                size={24} 
                color="var(--color-success)" 
                strokeWidth={2}
              />
            </div>
            <h4 className="font-body font-medium text-foreground mb-2">
              {feature.title}
            </h4>
            <p className="text-muted-foreground font-body text-xs leading-relaxed">
              {feature.description}
            </p>
          </div>
        ))}
      </div>

      {/* Trust Indicators */}
      <div className="mt-8 flex items-center justify-center space-x-8 opacity-60">
        <div className="flex items-center space-x-2">
          <Icon name="Award" size={16} color="var(--color-muted-foreground)" />
          <span className="text-muted-foreground font-body text-xs">
            NAR Certified
          </span>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="Shield" size={16} color="var(--color-muted-foreground)" />
          <span className="text-muted-foreground font-body text-xs">
            SOC 2 Compliant
          </span>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="Globe" size={16} color="var(--color-muted-foreground)" />
          <span className="text-muted-foreground font-body text-xs">
            99.9% Uptime
          </span>
        </div>
      </div>
    </div>
  );
};

export default SecurityBadges;